import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "../hoc/Container";
import {
  nintendo_img,
  playStation_img,
  steam_img,
  youtube_img,
  vk_img,
  telegram_img,
  newsale_nintendo,
  newsale_steam,
  newsale_playstation,
} from "../../images";

const saleImages = {
  nintendo: newsale_nintendo,
  steam: newsale_steam,
  playstation: newsale_playstation,
};

function MainPage() {
  useEffect(() => {
    window.ym(93997310, "hit", "/", {
      params: {
        title: "Main Page",
      },
    });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <Container>
      <section className="main-content-block main-stack">
        <article>
          <h1 className="main-title">
            Коды Nintendo eShop и PlayStation,
            <br />
            пополнение Steam
          </h1>
          <div className="flex justify-center">
            <p className="main-text main-text-small main-text-centered w-full text-gray-700 dark:text-white">
              Добро пожаловать в магазин блогера trendy_eng! Тут вы можете легко,
              просто и удобно купить подарочные карты для Nintendo eShop, Steam и
              PlayStation. С помощью этих кодов можно пополнить баланс в магазинах
              для покупки игр. Всегда в наличии коды Nintendo Switch, Steam (PC,
              Steam Deck), PlayStation 4 и PlayStation 5 (PSN). Удобная оплата
              через эквайринг или QR, моментальная доставка.
            </p>
          </div>
          <div className="mt-3">
            <div className="main-grid main-grid-shops">
              <div className="main-card">
                <Link
                  to={"/nintendo-eshop"}
                  className="main-card-link group"
                  aria-label="Перейти в магазин Nintendo eShop"
                >
                  <img
                    className="shop-img-large image-glow glow-nintendo transition duration-200 ease-out group-hover:scale-[1.02] group-active:scale-[0.99]"
                    src={nintendo_img}
                    alt="Nintendo eShop"
                  />
                </Link>
                <div className="main-card-info">
                  <h3 className="main-card-title">Пополнить Nintendo</h3>
                  <p className="main-muted">Польша 🇵🇱 (zl)</p>
                  <p className="main-muted">США 🇺🇸 ($)</p>
                </div>
              </div>
              <div className="main-card">
                <Link
                  to={"/steam"}
                  className="main-card-link group"
                  aria-label="Перейти в магазин Steam"
                >
                  <img
                    className="shop-img-large image-glow glow-steam transition duration-200 ease-out group-hover:scale-[1.02] group-active:scale-[0.99]"
                    src={steam_img}
                    alt="Steam"
                  />
                </Link>
                <div className="main-card-info">
                  <h3 className="main-card-title">Пополнить Steam</h3>
                  <p className="main-muted">Страны СНГ (RU, KZ и др.)</p>
                </div>
              </div>
              <div className="main-card">
                <Link
                  to={"/playstation"}
                  className="main-card-link group"
                  aria-label="Перейти в магазин PlayStation"
                >
                  <img
                    className="shop-img-large image-glow glow-psn transition duration-200 ease-out group-hover:scale-[1.02] group-active:scale-[0.99]"
                    src={playStation_img}
                    alt="PlayStation"
                  />
                </Link>
                <div className="main-card-info">
                  <h3 className="main-card-title">Пополнить PlayStation</h3>
                  <p className="main-muted">Польша 🇵🇱 (zl)</p>
                  <p className="main-muted">Индия 🇮🇳 (INR)</p>
                </div>
              </div>
            </div>
          </div>
        </article>
        <div className="main-divider" />
        <section>
          <h2 className="main-subtitle">Самые ожидаемые скидки</h2>
          <div className="main-grid main-grid-sales">
            <div className="sale-card">
              <Link
                to={"/nintendo-discount"}
                className="main-card-link group"
                aria-label="Скидки Nintendo eShop"
              >
                <img
                  className="sale-img image-glow glow-nintendo transition duration-200 ease-out group-hover:scale-[1.02] group-active:scale-[0.99]"
                  src={saleImages.nintendo}
                  alt="Nintendo eShop"
                />
              </Link>
              <div className="main-card-info">
                <h3 className="main-card-title main-card-title-small">
                  Скидки Nintendo
                </h3>
              </div>
            </div>
            <div className="sale-card">
              <Link
                to={"/steam-discount"}
                className="main-card-link group"
                aria-label="Скидки Steam"
              >
                <img
                  className="sale-img image-glow glow-steam-soft transition duration-200 ease-out group-hover:scale-[1.02] group-active:scale-[0.99]"
                  src={saleImages.steam}
                  alt="Steam"
                />
              </Link>
              <div className="main-card-info">
                <h3 className="main-card-title main-card-title-small">
                  Скидки Steam
                </h3>
              </div>
            </div>
            <div className="sale-card">
              <Link
                to={"/playstation-discount"}
                className="main-card-link group"
                aria-label="Скидки PlayStation"
              >
                <img
                  className="sale-img image-glow glow-psn transition duration-200 ease-out group-hover:scale-[1.02] group-active:scale-[0.99]"
                  src={saleImages.playstation}
                  alt="PlayStation"
                />
              </Link>
              <div className="main-card-info">
                <h3 className="main-card-title main-card-title-small">
                  Скидки PlayStation
                </h3>
              </div>
            </div>
          </div>
        </section>
        <div className="main-divider" />
        <address>
          <h2 className="main-subtitle main-subtitle-social">
            Наши социальные сети - комментарии всегда открыты
          </h2>
          <div className="flex flex-row flex-wrap items-center justify-center gap-2 md:gap-4">
            <div className="social-item">
              <a
                to={"https://www.youtube.com/channel/UCdfv-fZKGIobmzVxHX9mSAA"}
                href="https://www.youtube.com/channel/UCdfv-fZKGIobmzVxHX9mSAA"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => window.ym(93997310, "reachGoal", "youTubeClick")}
                className="main-social-link group"
                aria-label="Trendy Shop YouTube"
              >
                <img
                  className="social-img transition duration-200 ease-out group-hover:scale-105 group-active:scale-95"
                  src={youtube_img}
                  alt="Trendy Shop YouTube"
                />
              </a>
              <div className="social-text">
                <span className="social-title">YouTube</span>
                <span>75 000+</span>
                <span>подписчиков</span>
              </div>
            </div>
            <div className="social-item">
              <a
                href="https://t.me/trendy_eng"
                target="_blank"
                rel="noopener noreferrer"
                className="main-social-link group"
                aria-label="Trendy Shop Telegram"
              >
                <img
                  className="social-img transition duration-200 ease-out group-hover:scale-105 group-active:scale-95"
                  src={telegram_img}
                  alt="Trendy Shop Telegram"
                  onClick={() => window.ym(93997310, "reachGoal", "tgClick")}
                />
              </a>
              <div className="social-text">
                <span className="social-title">Telegram</span>
                <span>10 000+</span>
                <span>подписчиков</span>
              </div>
            </div>
            <div className="social-item">
              <a
                href="https://vk.com/trendy_eng"
                target="_blank"
                rel="noopener noreferrer"
                className="main-social-link group"
                aria-label="Trendy Shop Вконтакте"
              >
                <img
                  className="social-img transition duration-200 ease-out group-hover:scale-105 group-active:scale-95"
                  src={vk_img}
                  alt="Trendy Shop VK"
                  onClick={() => window.ym(93997310, "reachGoal", "vkClick")}
                />
              </a>
              <div className="social-text">
                <span className="social-title">Вконтакте</span>
                <span>16 000+</span>
                <span>подписчиков</span>
              </div>
            </div>
          </div>
        </address>
        <div className="main-divider" />
        <section className="reviews-section">
          <h2 className="main-subtitle main-subtitle-social">
            Отзывы покупателей
          </h2>
          <p className="reviews-text">
            Посмотреть реальные отзывы можно в нашей теме ВК.
          </p>
          <a
            href="https://vk.com/topic-213291589_48811365"
            target="_blank"
            rel="noreferrer"
            className="reviews-link"
          >
            Читать отзывы
          </a>
        </section>
      </section>
    </Container>
  );
}

export default MainPage;
